import { useQuery } from "react-query";
import { apiConfig } from "../../config/apiConfig";
import apiService from "../../service/apiService";
import { useCookie } from "../useCookie";

export function useGetDriverSessions(
  userId: string,
  filter: DriverSessionFilter,
) {
  const { token } = useCookie("vToken");

  const { data: drivers, isLoading: isLoadingDrivers } = useQuery(
    ["driverSessions", filter],
    async () => {
      const {
        date,
        notLogedIn = 0,
        page = 1,
        limit = 10,
        query,
        sortBy,
        range,
        status,
      } = filter;

      const endpoint = `${apiConfig.users.drivers.driver_sessions({
        ...(date && { date }),
        notLogedIn: notLogedIn,
        page,
        limit,
        query: query!,
        sortBy: sortBy!,
        range,
        status,
      })}`;
      const response = await apiService.MakeGetRequest(endpoint, token);

      return response;
    },
    {
      enabled: true,
    },
  );

  const { data: driverSessions, isLoading: isLoadingDriverSessions } = useQuery(
    ["Sessions", filter],
    async () => {
      const { date, page = 1, limit = 20, range } = filter;

      const endpoint = `${apiConfig.users.drivers.sessions(userId!, {
        ...(date && { date }),
        page,
        limit,
        range,
      })}`;
      const response = await apiService.MakeGetRequest(endpoint, token);

      return response;
    },
    {
      enabled: Boolean(userId),
    },
  );

  return {
    drivers: drivers,
    isDriverLoading: isLoadingDrivers,
    driverSessions: driverSessions,
    isLoadingSeesion: isLoadingDriverSessions,
  };
}
